import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import { installErrorLog } from './io/diagnostics/errorLog';

// 🚨 BEFORE REACT MOUNTS, DELIBERATELY. The errors most worth attaching to a
// bug report are the ones thrown while the app was starting - a failed boot
// read, a provider that threw - and a logger installed inside a component would
// miss every one of them. It only fills a small in-memory ring; nothing is sent
// anywhere unless the user presses Send feedback.
installErrorLog();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
